<template>
  <div class="home">
    <div id="contentPC">
      <div id="mainPC">
        <div id="phone"><img src="../assets/img/phone.png"></div>
        <div id="logo">
          <div id="logoItem">
            <img src="../assets/img/SMChatlogoPC.png" style="width: 116px;height: 116px;">
            <img id="homeLogoWord" src="../assets/img/SMChatlogo2PC.png" style="width: 183px;height: 43px;">
          </div>
          <div id="title">最新聊天體驗</div>
          <div id="subtitle">Show me yourself</div>
          <div><img src="../assets/img/appStorePC.png"></div>
        </div>
      </div>
    </div>
    <div id="contentMobile">
      <div id="mainMobile">
        <div id="logo">
          <div id="logoItem">
            <img src="../assets/img/SMChatlogoMobile.png" style="width: 90px;height: 90px;"><br>
            <img id="homeLogoWord" src="../assets/img/SMChatlogo2Mobile.png" style="width: 140px;height: 33px;">
          </div>
          <div id="title">最新聊天體驗</div>
          <div id="subtitle">Show me yourself</div>
          <div><img src="../assets/img/appStoreMobile.png"></div>
        </div>
      </div>
    </div>
    <navBar/>
    <background/>
  </div>
</template>

<script>
// @ is an alias to /src
import navBar from '@/components/navBar.vue'
import background from '@/components/background.vue'

export default {
  name: 'Home',
  components: {
    navBar,
    background
  }
}
</script>

<style>
  @media screen and (max-width: 767px) {
    #contentMobile{
      display: block;
      overflow: auto;
      height: calc(100vh - 202px);
    }
    #contentPC{ display: none; }
    #mainMobile{
      margin-top: 20vh;
      margin-bottom: 150px;
    }
    #logo{
      text-align: center;
    }
    #homeLogoWord{
      margin: 16px 0 18px 0;
    }
    #title{
      font-size: 25px;
      font-weight: bold;
      line-height: 1.32;
      color: #413846;
    }
    #subtitle{
      font-size: 14px;
      line-height: 1.36;
      color: #413846;
      margin-bottom:13px;
    }
  }
  @media screen and (min-width: 768px) {
    #contentMobile{ display: none; }
    #contentPC{
      display: block;
      overflow: auto;
      height: calc(100vh - 77px);
    }
    #mainPC{
      display: flex;
      margin-top: 25vh;
    }
    #phone{
      flex-basis: 50%;
      display: flex;
      justify-content: flex-end;
    }
    #phone img{
      margin-right: 2vw;
    }
    #logo{
      flex-basis: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    #logo a{
      margin-right: 2vw;
    }
    #logoItem{
      align-items: center;
      display: flex;
      margin-bottom: 13px;
    }
    #title{
      font-size: 45px;
      font-weight: bold;
      line-height: 1.31;
      color: #413846;
    }
    #subtitle{
      margin-bottom:23px;
      font-size: 26px;
      line-height: 1.35;
      letter-spacing: 2.86px;
      color: #413846;
    }
    #homeLogoWord{ margin-left:24px; }
  }
</style>
